import React from "react";
import _ from "lodash";

import ActivityType from "./ActivityType";
import TeamSessions from "./TeamSessions";

const MiddleSection = ({
  link,
  history,
  sessionId,
  session_id,
  currentUser,
  team_session,
  sessionUsers,
  pick_activity,
  set_session_id,
  teamSessionRef,
  socket_connected,
}) => {
  return (
    <section className="middle-section">
      <div className="container">
        <div className="row">
          <ActivityType pick_activity={pick_activity} />
          <TeamSessions
            link={link}
            history={history}
            sessionId={sessionId}
            session_id={session_id}
            currentUser={currentUser}
            sessionUsers={sessionUsers}
            team_session={team_session}
            set_session_id={set_session_id}
            teamSessionRef={teamSessionRef}
            socket_connected={socket_connected}
          />
        </div>
      </div>
    </section>
  );
};

export default MiddleSection;
